import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, inject, Signal, signal } from '@angular/core';
import { IconType, ApiHttpResponse, Playlist } from '@kinomap-dev/ng-ui-lib/core';
import { EmptyContentListElement } from '../../../components/empty-content-list-element/empty-content-list-element';
import { Paginator } from '../../../components/paginator/paginator';
import { Table } from '../../../components/table/table';
import { ProfileService } from '../../../services/profile.service';
import { TableContentService, CONTENT_TYPE_TOKEN } from '../../../services/table-content.service';
import { convertPlaylistToPlaylistContentTableItem } from '../../../utils/playlist-to-playlist-content-table-data.helpers';
import { FilterService } from '../../../services/filters.service';
import { TableColumnsService } from '../../../services/table-columns.service';

const tableHeaderElements: string[] = [
  'sport',
  'duration',
  'level',
  'sessions',
  'comments',
  'likes',
  // 'labels', // Hidden while the tags topic is on standby
];

@Component({
  selector: 'app-playlist-list',
  imports: [NgTemplateOutlet, EmptyContentListElement, Table, Paginator],
  providers: [
    FilterService,
    TableContentService,
    TableColumnsService,
    { provide: CONTENT_TYPE_TOKEN, useValue: 'playlist' },
  ],
  templateUrl: './playlist-list.html',
  styleUrl: '../content-list.scss',
})
export class PlaylistList {
  public playlistTableContentService: TableContentService = inject(TableContentService);
  readonly tableColumnsService: TableColumnsService = inject(TableColumnsService);
  profileService: ProfileService = inject(ProfileService);

  readonly emptyList: Signal<boolean> = computed(
    () => (this.profileService.profile()?.playlists_count ?? 0) === 0,
  );
  readonly actions: Signal<IconType[]> = signal<IconType[]>(['edit', 'options']);
  readonly playlistTableData: Signal<ApiHttpResponse<Playlist[]> | undefined> = this
    .playlistTableContentService.tableData as Signal<ApiHttpResponse<Playlist[]>>;

  private profilePlaylistCount = computed(
    () => this.profileService.profile()?.playlists_count ?? 0,
  );
  readonly skeletonCount: Signal<number> = computed(() => {
    if (this.profilePlaylistCount() < this.playlistTableContentService.contentLimitPerPage()) {
      return this.profilePlaylistCount();
    }
    return this.playlistTableContentService.contentLimitPerPage();
  });

  readonly tableData: Signal<any[] | undefined> = computed(() => {
    const data: Playlist[] | undefined = this.playlistTableData()?.data;
    if (!data || !Array.isArray(data)) return undefined;
    return data.map((row: Playlist) => {
      return convertPlaylistToPlaylistContentTableItem(row);
    });
  });

  constructor() {
    this.tableColumnsService.setColumns(tableHeaderElements);
  }
}
